export type SafetrustPropertiesType = {
  applicationUUID: string;
  sdkUUID: string;
  credentialManagerServiceUrl: string;
  supportEmail: string;
  helpPageURL: string;
  privacyConfidentialityStatements: string;
  dataControllerEmail: string;
};

export enum SafetrustFeedbackEnum {
  None = 'None',
  Vibration = 'Vibration',
  RingerAndVibration = 'Vibrate & Ring',
}
